import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FileQuestion, Home, LayoutDashboard, ArrowLeft } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { authService } from '../services/authService';

const NotFound = () => {
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 overflow-x-hidden min-h-[70vh] flex flex-col items-center justify-center">
      <Card className="max-w-xl w-full">
        <CardHeader className="pb-2 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <FileQuestion className="h-8 w-8 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl sm:text-3xl font-bold text-foreground">
            404
          </CardTitle>
          <p className="text-lg font-semibold text-foreground mt-1">
            Page Not Found
          </p>
        </CardHeader>
        <CardContent className="pt-0 space-y-6">
          <p className="text-center text-muted-foreground text-sm sm:text-base">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
            {isAuthenticated ? (
              <Button asChild variant="default" size="sm" className="w-full">
                <Link to="/dashboard">
                  <LayoutDashboard className="h-4 w-4 mr-2" />
                  Dashboard
                </Link>
              </Button>
            ) : (
              <Button asChild variant="default" size="sm" className="w-full">
                <Link to="/">
                  <Home className="h-4 w-4 mr-2" />
                  Go Home
                </Link>
              </Button>
            )}
          </div>
          {isAuthenticated && (
            <div className="text-center">
              <Button asChild variant="ghost" size="sm">
                <Link to="/">
                  <Home className="h-4 w-4 mr-2" />
                  Home
                </Link>
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
